export async function updateEmoticon() {
  window?.Kakao?.Emoticon?.update('kakao_emoticon');
}
